import { TGraphItems } from "modules/types/advanced_stats";
import React from "react";
import { HubStatsTitle, HubStatsWrapper, GraphWrapper, GraphTitleValue } from "apps/BWW_PLAY_HUB/components/HubStats/styles";
import {
	HubStatsLegend
} from "apps/BWW_PLAY_HUB/components/HubStats/HubStatsLegend";
import {
	HubStatsDaysGraph
} from "apps/BWW_PLAY_HUB/components/HubStats/HubStatsDaysGraph";
import { EnumStatsType, getPercent } from "apps/BWW_PLAY_HUB/components/HubStats/utils";
import { useSelector } from "react-redux";
import { getHubStats } from "apps/BWW_PLAY_HUB/modules/selectors/hub_stats";
import { union, max, forEach, get, orderBy } from "lodash";
import styled from "styled-components";


const HubStatsDaysGraphStyled = styled(HubStatsDaysGraph)`
	justify-content: space-between;
`;

const legend_items = [
	{
		type: EnumStatsType.pp,
	},
	// {
	// 	type: EnumStatsType.trivia,
	// },
];

export const DaysPlayed: React.FC = () => {
	const { pp, trivia } = useSelector(getHubStats);

	const pp_daily_numbers_played_contests = pp.daily_numbers_played_contests;
	const trivia_daily_numbers_played_contests = trivia.daily_numbers_played_contests;

	const pp_keys: string[] = [];
	const pp_values: number[] = [];
	const trivia_keys: string[] = [];
	const trivia_values: number[] = [];

	Object.entries(pp_daily_numbers_played_contests).forEach(([ key, value ]) => {
		pp_keys.push(key);
		pp_values.push(value);
	});

	Object.entries(trivia_daily_numbers_played_contests).forEach(([ key, value ]) => {
		trivia_keys.push(key);
		trivia_values.push(value);
	});

	const max_value = max([ ...pp_values, ...trivia_values ]) || 0;

	if ( !max_value ) {
		return null;
	}

	const union_keys = union(pp_keys, trivia_keys);

	const days_graph_values: TGraphItems = {};

	forEach(union_keys, (value) => {
		const pp_value = get(pp_daily_numbers_played_contests, value, 0);
		const pp_percent = getPercent(pp_value, max_value);

		const arr = [
			{
				type   : EnumStatsType.pp,
				value  : pp_value,
				percent: pp_percent,
			},
			// {
			// 	type   : EnumStatsType.trivia,
			// 	value  : trivia_value,
			// 	percent: trivia_percent,
			// },
		];

		days_graph_values[value] = orderBy(arr, ['value'], ['asc']);
	});

	return (
		<HubStatsWrapper>
			<HubStatsTitle>What days do you like to play (total)</HubStatsTitle>
			<GraphWrapper>
				<GraphTitleValue>{ max_value }</GraphTitleValue>
				<HubStatsDaysGraphStyled items={days_graph_values} format={null} />
			</GraphWrapper>
			<HubStatsLegend items={legend_items} show_value={false} show_percent={false} />
		</HubStatsWrapper>
	);
};
